const getBuyOrViewProductMetaTag = (action, retailerName, productName, productId, stacklineSku, productUrl, productPrice) => {
    return {
        id: `${retailerName}_${action}`,
        'data-vendor': retailerName,
        'data-action': action,
        'data-product-name': productName,
        'data-product-id': productId,
        'data-stackline-sku': stacklineSku,
        'data-product-url': productUrl,
        'data-product-price': productPrice,
    };
};

export { getBuyOrViewProductMetaTag };
//# sourceMappingURL=dataLayer.js.map
